import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/customer/_modal")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<Outlet />
		</>
	);
}
